export const truncate = `
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`
